module.exports = __webpack_public_path__ + "img/pattern2.353213b.svg";